module.exports = __webpack_public_path__ + "static/media/hamburger.2f7ff2b5.gif";